import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersBusinessDivisionsEditResponseType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersBusinessDivisionsEditResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBusinessDivisionsEditResponseType>(
      `/api/managers/business_divisions/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersBusinessDivisionsEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersBusinessDivisionsEditResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersBusinessDivisionsEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
